export * from "./ssaoRenderingPipeline.pure";

import "../../../Rendering/depthRendererSceneComponent";
import "../../../Shaders/ssao.fragment";
import "../../../Shaders/ssaoCombine.fragment";
